/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Folder, AssetOption, AssetOptionType, translate } from '@wit/vtv-x-foundation-lib';

function getOptions(folders: Folder[]): AssetOption[] {
  const options: AssetOption[] = [];

  folders.forEach((folder) => {
    options.push({
      key: `${AssetOptionType.EXPLORE_FOLDER}-${folder.id}`,
      type: AssetOptionType.EXPLORE_FOLDER,
      title: translate.formatString(translate['pi.options.folder'], folder.title).toString(),
      asset: folder,
    });
  });

  return options;
}

export default {
  getOptions,
};
